import React, { useEffect } from 'react';
import "../assets/css/DashboardCard.css";

const DashboardCard = ({ title, content, loading }) => {

  useEffect(() => {
    const cards = document.querySelectorAll('.card');
    let maxWidth = 0;

    cards.forEach(card => {
      const cardWidth = card.offsetWidth;
      if (cardWidth > maxWidth) {
        maxWidth = cardWidth;
      }
    });

    cards.forEach(card => {
      card.style.width = `${maxWidth}px`;
    });
  }, []);
  
  return (
    <div className="card">
      {loading ? (
        <span class="loader" />
      ) : (
        <>
        <h3>{title}</h3>
        <p>{content}</p>
        </>
      )}
    </div>
  );
};

export default DashboardCard;
